module.exports = __webpack_public_path__ + "static/media/logo.a34f3909.jpg";